export default __webpack_public_path__ + "images/dtdc-b2b.png";